import PropTypes from "prop-types";
import classNames from "classnames";
import NavMenuItem from "./NavMenuItem/NavMenuItem";
import classes from "./NavMenu.module.css";

const NavMenu = (props) => {
  const { className, header, menu } = props;

  return (
    <div className={classes["nav-menu"]}>
      <h3 className={classes["nav-menu__header"]}>{header}</h3>
      <nav>
        <ul className={classNames(classes["nav-menu__list"], className)}>
          {menu.map((menuItem, index) => (
            <NavMenuItem key={index} label={menuItem.label} to={menuItem.to} />
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default NavMenu;

NavMenu.propTypes = {
  className: PropTypes.string,
  header: PropTypes.string,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      to: PropTypes.string,
    })
  ),
};
